import { INVITE_EMAIL_DESIGN_SCOPE_ROWS } from 'features/InviteEmailDesign/inviteEmailDesignScopeRows'
import { getBulkMediumScopeStatus, getBulkMediumScopeSupportsEmailDesign } from 'features/ManageCampaigns/utils/inviteBulkMediumHelpers'

export const CAMPAIGN_GROUP_MODES = {
  all: 'all',
  custom: 'custom'
}

export const CAMPAIGN_GROUP_MODE_OPTIONS = {
  [CAMPAIGN_GROUP_MODES.all]: 'All campaigns',
  [CAMPAIGN_GROUP_MODES.custom]: 'Custom'
}

export function getInviteScopeRowsForCampaignGroupMode(campaignGroupMode) {
  if (campaignGroupMode === CAMPAIGN_GROUP_MODES.custom) {
    return INVITE_EMAIL_DESIGN_SCOPE_ROWS.filter(row => row.scope !== CAMPAIGN_GROUP_MODES.all)
  }

  return INVITE_EMAIL_DESIGN_SCOPE_ROWS.filter(row => row.scope === CAMPAIGN_GROUP_MODES.all)
}

export function getInviteEmailTemplateVisibleScopeRows(
  campaignGroupMode,
  campaigns,
  mediumOverrides = {}
) {
  return getInviteScopeRowsForCampaignGroupMode(campaignGroupMode).filter(row =>
    getBulkMediumScopeSupportsEmailDesign(campaigns, row.scope, mediumOverrides)
  )
}

const INVITE_CAMPAIGN_GROUP_MODE_STORAGE_PREFIX = 'invite-campaign-group-mode'

export function getInviteCampaignGroupModeStorageKey(contentSubsidiaryId) {
  return `${INVITE_CAMPAIGN_GROUP_MODE_STORAGE_PREFIX}-${contentSubsidiaryId}`
}

export function readStoredInviteCampaignGroupMode(contentSubsidiaryId) {
  if (!contentSubsidiaryId) {
    return null
  }

  try {
    const stored = window.localStorage.getItem(getInviteCampaignGroupModeStorageKey(contentSubsidiaryId))

    if (stored === CAMPAIGN_GROUP_MODES.all || stored === CAMPAIGN_GROUP_MODES.custom) {
      return stored
    }
  } catch {
    return null
  }

  return null
}

export function writeStoredInviteCampaignGroupMode(contentSubsidiaryId, campaignGroupMode) {
  if (!contentSubsidiaryId) {
    return
  }

  try {
    window.localStorage.setItem(
      getInviteCampaignGroupModeStorageKey(contentSubsidiaryId),
      campaignGroupMode
    )
  } catch {
    // Ignore storage failures and keep in-memory state.
  }
}

export function resolveInitialInviteCampaignGroupMode(contentSubsidiaryId, campaigns = []) {
  const storedMode = readStoredInviteCampaignGroupMode(contentSubsidiaryId)

  if (storedMode) {
    return storedMode
  }

  if (campaigns.length && getBulkMediumScopeStatus(campaigns).hasSubsetOverrides) {
    return CAMPAIGN_GROUP_MODES.custom
  }

  return CAMPAIGN_GROUP_MODES.all
}
